export const COMMA_SPACE_NEWLINE_SEPARATORS = [',', ' ', '\n'];
export const COMMA_SPACE_NEWLINE_SEPARATORS_PLACEHOLDER = 'Use comma, space, or enter to separate items';